var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21C18.8137 21 21.5 18.3137 21.5 15C21.5 11.6863 18.8137 9 15.5 9C12.1863 9 9.5 11.6863 9.5 15C9.5 18.3137 12.1863 21 15.5 21Z",
    fill: "#242424"
  })));
}

export default SvgDot;